<template>
  <span>
    <div class="filter-header__dense">
      <div
        :class="[
          'header-name-display',
          singleIcon ? 'single-icon' : '',
          hideFilterInput ? 'no-filter' : '',
        ]"
      >
        <sort-icons
          v-show="!hideFilterInput"
          :sort-dir="sortDir"
          @change="(dir) => changeSort(dir, label)"
        />
        <div class="header-text-display">
          <slot>
            <span>{{ label }}</span>
          </slot>
        </div>
      </div>
      <multi-type-filter-input
        v-if="!hideFilterInput"
        :value="value"
        :type="type"
        :filter-type="filterType"
        @updated="updateFilter"
      />
      <div v-else class="input-controls" />
    </div>
  </span>
</template>

<script>
import types from '../../static/tables/types.js';
import SortIcons from './SortIcons.vue';
import MultiTypeFilterInput from './MultiTypeFilterInput.vue';

export default {
  name: 'FilterHeader',
  components: {
    SortIcons,
    MultiTypeFilterInput,
  },
  props: {
    value: {
      type: [String, Number, Date],
      default: undefined,
    },
    label: {
      type: String,
      default: 'Filter',
    },
    type: {
      type: String,
      default: 'text',
      validator: (value) => Object.values(types).includes(value),
    },
    filterType: {
      type: String,
      default: 'equal',
      validator: (value) =>
        ['equal', 'less', 'greater', 'empty'].includes(value),
    },
    sortDir: {
      type: String,
      default: 'default',
    },
    /**
     * If the input for filtering the column should be hidden, so only the
     * header is displayed. This hides both the filter input AND the sort
     * icons
     */
    hideFilterInput: {
      type: Boolean,
      default: false,
    },
    singleIcon: {
      type: Boolean,
    },
    clearInputs: {
      type: Boolean,
    },
  },
  watch: {
    clearInputs() {
      if (this.clearInputs) {
        this.updateFilter({});
      }
    },
  },
  methods: {
    updateFilter({ value, filterType }) {
      this.$emit('input', value);
      if (filterType !== this.filterType && filterType !== undefined) {
        this.$emit('updated:filter', filterType);
      }
    },
    changeSort(sortOrder, columnHeader) {
      this.$emit('change:header', columnHeader);
      this.$emit('updated:sort', sortOrder);
      this.sortDir = sortOrder;
    },
  },
};
</script>

<style>
.filter-header__dense {
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 6px;
}
.filter-header__dense label {
  color: var(--text, #0f172a);
  white-space: nowrap;
  padding: 10px;
}
.header-name-display {
  margin-bottom: 36px;
  display: flex;
  align-items: center;
}
.header-text-display {
  white-space: pre-wrap;
}
.single-icon .header-text-display {
  padding-right: 4px;
}
.header-text-display > .v-icon {
  padding-top: 10px;
}
</style>
